<template>
  <div class="old-gold-container">
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#0f172a"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#1e293b" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>

        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-card flat class="estimate-gold-card mb-4 rounded-lg">
      <div class="card-top-bar px-4 py-3 d-flex align-center justify-space-between" @click="show = !show" style="cursor: pointer;">
        <div class="d-flex align-center">
          <v-icon small color="#475569" class="mr-2">mdi-gold</v-icon>
          <span class="card-heading">Old Gold Exchange</span>
          <span v-if="List && List.length > 0" class="items-count-badge ml-2">{{ List.length }} items</span>
        </div>
        <v-btn icon small @click.stop="show = !show">
          <v-icon color="#64748b">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </div>

      <v-expand-transition>
        <div v-show="show">
          <v-divider></v-divider>
          <div class="pa-4">
            <div class="old-gold-grid">
              <div class="grid-item">
                <label class="erp-field-label">Item Type</label>
                <v-select
                  v-model="oldGold.itemName"
                  :items="['Old Gold', 'Old Silver']"
                  outlined
                  dense
                  hide-details
                  class="erp-field"
                  color="#9a6b27"
                  placeholder="Select Item"
                  @change="onOldGoldItemChange"
                ></v-select>
              </div>

              <div class="grid-item">
                <label class="erp-field-label">Rate (₹)</label>
                <v-text-field
                  v-model="oldGold.goldRate"
                  outlined
                  dense
                  hide-details
                  class="erp-field"
                  type="number"
                  color="#9a6b27"
                  placeholder="Rate"
                ></v-text-field>
              </div>

              <div class="grid-item">
                <label class="erp-field-label">Gross Wt (gm)</label>
                <v-text-field
                  v-model="oldGold.grossWeight"
                  outlined
                  dense
                  hide-details
                  class="erp-field"
                  @input="cal1()"
                  type="number"
                  color="#9a6b27"
                  placeholder="0.000"
                ></v-text-field>
              </div>

              <div class="grid-item">
                <label class="erp-field-label">Stone Wt (gm)</label>
                <v-text-field
                  type="number"
                  v-model="oldGold.stoneWeight"
                  outlined
                  dense
                  hide-details="auto"
                  class="erp-field"
                  @input="cal1()"
                  color="#9a6b27"
                  placeholder="0.000"
                ></v-text-field>
              </div>

              <div class="grid-item">
                <label class="erp-field-label">Net Wt (gm)</label>
                <v-text-field
                  v-model="oldGold.netWeight"
                  outlined
                  dense
                  disabled
                  hide-details
                  class="erp-field erp-readonly font-weight-medium"
                  type="number"
                  color="#9a6b27"
                  placeholder="0.000"
                ></v-text-field>
              </div>

              <div class="grid-item">
                <label class="erp-field-label">Melt (%)</label>
                <v-text-field
                  v-model="oldGold.melt"
                  outlined
                  dense
                  hide-details
                  class="erp-field"
                  type="number"
                  color="#9a6b27"
                  placeholder="Melt %"
                ></v-text-field>
              </div>

              <div class="grid-action-item">
                <label class="erp-field-label action-label-placeholder" aria-hidden="true">&nbsp;</label>
                <v-btn
                  @click="validate()"
                  dark
                  class="erp-add-gold-btn"
                  title="Add Old Gold"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </div>
            </div>
          </div>

          <!---------------------Table-------------------------->
          <div class="px-4 pb-4" v-if="List && List.length > 0">
            <v-card outlined class="rounded-lg overflow-hidden erp-table-card">
              <v-simple-table dense class="erp-gold-table m-stack-table m-stack-grid">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">#</th>
                      <th class="text-left">Item Name</th>
                      <th class="text-right">Rate (₹)</th>
                      <th class="text-right">Gross Wt (gm)</th>
                      <th class="text-right">Stone Wt (gm)</th>
                      <th class="text-right">Net Wt (gm)</th>
                      <th class="text-right">Melt (%)</th>
                      <th class="text-right">{{ standalone ? 'Payable Amt (₹)' : 'Deduction Amt (₹)' }}</th>
                      <th class="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, i) in List" :key="i" class="table-row-hover">
                      <td data-label="#">{{ i + 1 }}</td>
                      <td data-label="Item Name" class="font-weight-medium">{{ value.itemName || '-' }}</td>
                      <td data-label="Rate (₹)" class="text-right">{{ value.goldRate || '-' }}</td>
                      <td data-label="Gross Wt (gm)" class="text-right">{{ (value.grossWeight || 0).toFixed(2) }}</td>
                      <td data-label="Stone Wt (gm)" class="text-right">{{ (value.stoneWeight || 0).toFixed(2) }}</td>
                      <td data-label="Net Wt (gm)" class="text-right font-weight-medium">{{ (value.netWeight || 0).toFixed(2) }}</td>
                      <td data-label="Melt (%)" class="text-right">{{ value.melt || 0 }}%</td>
                      <td data-label="Payable Amt (₹)" class="text-right font-weight-bold text-success">{{ standalone ? '' : '- ' }}₹ {{ value.itemAmount ? value.itemAmount.toFixed(2) : '0.00' }}</td>
                      <td data-label="Actions" class="text-center">
                        <v-btn
                          icon
                          x-small
                          class="mr-1"
                          color="#475569"
                          title="Edit"
                          @click="
                            (curitem = value),
                            (editdialogue = true)
                          "
                        >
                          <v-icon small>mdi-pencil-outline</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          x-small
                          color="#dc2626"
                          title="Remove"
                          @click="(dialoge = true), (curId = value._id)"
                        >
                          <v-icon small>mdi-delete-outline</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <!-- Table Summary Footer Bar -->
              <div class="table-summary-bar px-4 py-3 d-flex justify-end align-center flex-wrap" v-if="saledata">
                <div class="summary-pill mr-3" v-if="saledata.totalNetWeight">
                  <span class="pill-label">Old Gold Wt:</span>
                  <span class="pill-val font-weight-bold">{{ saledata.totalNetWeight.toFixed(2) }} gm</span>
                </div>
                <div class="summary-pill highlight-pill" v-if="saledata.totalAmount">
                  <span class="pill-label">{{ standalone ? 'Amount Payable to Customer:' : 'Buyback Deduction:' }}</span>
                  <span class="pill-val font-weight-bold">{{ standalone ? '' : '- ' }}₹ {{ saledata.totalAmount.toFixed(2) }}</span>
                </div>
              </div>
            </v-card>
          </div>
        </div>
      </v-expand-transition>
    </v-card>

    <!-- Delete Confirmation Dialog -->
    <v-dialog width="420px" v-model="dialoge">
      <v-card class="rounded-lg erp-modal-card">
        <div class="modal-top-bar px-5 py-4 d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <v-icon color="#dc2626" class="mr-2">mdi-alert-circle-outline</v-icon>
            <span class="modal-title">Remove Old Gold Item</span>
          </div>
          <v-btn icon small @click="dialoge = false">
            <v-icon color="#64748b">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <div class="pa-5 font-weight-regular" style="color: #334155; font-size: 14px;">
          Are you sure you want to remove this old gold exchange item?
        </div>
        <v-divider></v-divider>
        <div class="px-5 py-3 d-flex justify-end align-center bg-modal-footer">
          <v-btn text color="#64748b" class="mr-2 text-capitalize" @click="dialoge = false">Cancel</v-btn>
          <v-btn color="#dc2626" dark class="text-capitalize px-4 rounded-lg" @click="deleteStaff()">
            <v-icon left small>mdi-delete</v-icon>
            Remove
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Edit Old Gold Item Dialog -->
    <v-dialog width="680px" v-model="editdialogue">
      <v-card class="rounded-lg erp-modal-card">
        <div class="modal-top-bar px-5 py-4 d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <v-icon color="#0f172a" class="mr-2">mdi-pencil-outline</v-icon>
            <div>
              <div class="modal-title">Edit Old Gold Item</div>
              <div class="modal-subtext">Update weights, rate or melt percentage</div>
            </div>
          </div>
          <v-btn icon small @click="editdialogue = false">
            <v-icon color="#64748b">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <div class="pa-5">
          <v-row dense>
            <v-col cols="12" sm="4" class="py-1">
              <label class="erp-field-label">Item Type</label>
              <v-select
                v-model="curitem.itemName"
                :items="['Old Gold', 'Old Silver']"
                outlined
                dense
                hide-details
                class="erp-field"
                color="#9a6b27"
                @change="onCurItemChange"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="4" class="py-1">
              <label class="erp-field-label">Gold Rate (₹)</label>
              <v-text-field
                v-model="curitem.goldRate"
                outlined
                dense
                type="number"
                color="#9a6b27"
                hide-details
                class="erp-field"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" class="py-1">
              <label class="erp-field-label">Gross Wt (gm)</label>
              <v-text-field
                v-model="curitem.grossWeight"
                outlined
                dense
                @input="editcal1()"
                type="number"
                color="#9a6b27"
                hide-details
                class="erp-field"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" class="py-1">
              <label class="erp-field-label">Stone Wt (gm)</label>
              <v-text-field
                type="number"
                v-model="curitem.stoneWeight"
                outlined
                dense
                @input="editcal1()"
                color="#9a6b27"
                hide-details
                class="erp-field"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" class="py-1">
              <label class="erp-field-label">Net Wt (gm)</label>
              <v-text-field
                v-model="curitem.netWeight"
                outlined
                dense
                disabled
                type="number"
                color="#9a6b27"
                hide-details
                class="erp-field erp-readonly font-weight-medium"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" class="py-1">
              <label class="erp-field-label">Melt (%)</label>
              <v-text-field
                v-model="curitem.melt"
                outlined
                dense
                type="number"
                color="#9a6b27"
                hide-details
                class="erp-field"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <div class="px-5 py-3 d-flex justify-end align-center bg-modal-footer">
          <v-btn text color="#64748b" class="mr-2 text-capitalize" @click="editdialogue = false">Cancel</v-btn>
          <v-btn dark class="erp-action-btn text-capitalize px-5" @click="editvalidate()">
            <v-icon left small>mdi-check</v-icon>
            Update Item
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["title2", "standalone"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 2000,
      msg: null,
      addcat:false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      juwellaryId: localStorage.getItem("juwellaryId"),

      oldGold: {
        itemName:"",
        goldRate: localStorage.getItem("goldRate"),
        quantity: "",
        grossWeight: "",
        netWeight: "",
        stoneWeight: "",
        melt: "",
        itemAmount: "",
      },
      peritem: {
        itemName:"",
        metalType:"Gold",
        goldRate: "",
        quantity: "",
        grossWeight: "",
        netWeight: "",
        stoneWeight: "",
        melt: "",
        itemAmount: "",
      },
      oldItemz:[],
      List: [],
      saledata: [],
      ItemList:[],
      dtype:false,
      curitem:{},
      itemz2:[],
      editdialogue: false,
      curId:null,
      dialoge:false,
      total3:"",
      salesId:null,
      show: false,
    };
  },
  mounted() {
    this.salesId=this.title2._id;
    console.log("saleid2222==",this.salesId)

  },
  watch: {
    title2() {
      console.log("title2==",this.title2)
      this.salesId=this.title2._id;
      console.log("saleid==",this.salesId)
    },
    salesId(){
      this.getData();
    }
  },
  methods: {
    onOldGoldItemChange(value) {
      if (value === "Old Silver") {
        this.oldGold.goldRate = localStorage.getItem("silverRate");
      } else {
        this.oldGold.goldRate = localStorage.getItem("goldRate");
      }
    },
    onCurItemChange(value) {
      if (value === "Old Silver") {
        this.curitem.goldRate = localStorage.getItem("silverRate");
      } else {
        this.curitem.goldRate = localStorage.getItem("goldRate");
      }
    },
    maxValueRule(grossWeight, stoneWeight) {
      return () => {
      if (stoneWeight >= grossWeight) {
        return `Stone weight cannot be greater than gross weight (${grossWeight})`;
      }
      return true;
    };
  
  },
  //add
    validate() {
      if (!this.oldGold.itemName) {
        this.msg = "Please enter item name";
        this.showsnackbar = true;
        return;
      } else if (!this.oldGold.goldRate) {
        this.msg = "Please enter gold rate";
        this.showsnackbar = true;
        return;
      } 
       else if (!this.oldGold.grossWeight) {
        this.msg = "Please enter gross weight";
        this.showsnackbar = true;
        return;
      } 
      else if (!this.oldGold.melt) {
        this.msg = "Please enter melt";
        this.showsnackbar = true;
        return;
      }
       else  if(this.oldGold.stoneWeight){
        var grosswt = parseFloat(this.oldGold.grossWeight);
        var stonewt = parseFloat(this.oldGold.stoneWeight);

        if (grosswt<=stonewt) {
        this.msg = "Stone weight should be less than gross weight";
        this.showsnackbar = true;
        return;
      }
      else{
        this.cal2();
      }
      }
       else {
        this.cal2();
      }
    },
    cal1() {
      if(this.oldGold.stoneWeight){
        
      // this.oldGold.netWeight = (this.oldGold.grossWeight*this.oldGold.quantity) - this.oldGold.stoneWeight;
      this.oldGold.netWeight = this.oldGold.grossWeight - this.oldGold.stoneWeight;
      
      }
      else{
        // this.oldGold.netWeight = this.oldGold.grossWeight*this.oldGold.quantity;
        this.oldGold.netWeight = this.oldGold.grossWeight;

      }
    },
    cal2() {
      console.log("1")
      if(this.oldGold.melt){
var value=this.oldGold.netWeight * this.oldGold.goldRate;
var newval =value*(this.oldGold.melt/100);
this.oldGold.itemAmount=value-newval;
console.log("totalwithmelt==",this.oldGold.itemAmount)
      }
      else{
      this.oldGold.itemAmount = this.oldGold.netWeight * this.oldGold.goldRate
console.log("totalwithoutmelt==",this.oldGold.itemAmount)

      }
      this.addValues();
    },
    //edit
    editvalidate() {
      if (!this.curitem.itemName) {
        this.msg = "Please enter item name";
        this.showsnackbar = true;
        return;
      } else if (!this.curitem.goldRate) {
        this.msg = "Please enter gold rate";
        this.showsnackbar = true;
        return;
      } 
       else if (!this.curitem.grossWeight) {
        this.msg = "Please enter gross weight";
        this.showsnackbar = true;
        return;
      }
      
       else  if(this.curitem.stoneWeight){
        var grosswt1 = parseFloat(this.curitem.grossWeight);
        var stonewt1 = parseFloat(this.curitem.stoneWeight);
        if (grosswt1<=stonewt1) {
        this.msg = "Stone weight should be less than gross weight";
        this.showsnackbar = true;
        return;
      }
        else{
          this.editcal2();
        }
     
      }
       else {
        this.editcal2();
      }
    },
    editcal1() {
      if(this.curitem.stoneWeight){
      
      // this.curitem.netWeight = (this.curitem.grossWeight*this.curitem.quantity) - this.curitem.stoneWeight;
      this.curitem.netWeight = this.curitem.grossWeight - this.curitem.stoneWeight;
     
      }
      else{
        // this.curitem.netWeight = this.curitem.grossWeight*this.curitem.quantity;
        this.curitem.netWeight = this.curitem.grossWeight;

      }
    },
    editcal2() {
      console.log("1")
      if(this.curitem.melt){
var value=this.curitem.netWeight * this.curitem.goldRate;
var newval =value*(this.curitem.melt/100);
this.curitem.itemAmount=value-newval;
console.log("totalwithmelt==",this.curitem.itemAmount)
      }
      else{
      this.curitem.itemAmount = this.curitem.netWeight * this.curitem.goldRate
console.log("totalwithoutmelt==",this.curitem.itemAmount)

      }
      this.editItem();
    },
    //
    addValues() {
      console.log("2")
      this.peritem.itemName = this.oldGold.itemName;
      this.peritem.metalType = this.oldGold.itemName === "Old Silver" ? "Silver" : "Gold";
      this.peritem.goldRate = this.oldGold.goldRate;
      // this.peritem.quantity = this.oldGold.quantity;
      this.peritem.grossWeight = this.oldGold.grossWeight;
      this.peritem.netWeight = this.oldGold.netWeight;
      this.peritem.stoneWeight = this.oldGold.stoneWeight;
      this.peritem.melt = this.oldGold.melt;
      this.peritem.itemAmount = this.oldGold.itemAmount;
      this.addVariant();
    },
    addOldItem() {
      console.log("4")
      this.datareload=false;
      axios({
        url: "/oldgold/add",
        method: "POST",
        data: {
          isOldGold:true,
          items: this.oldItemz,
          salesId: this.salesId,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
           this.msg = response.data.msg;
            this.showsnackbar = true;
            this.oldGold.itemName = null;
      // this.oldGold.quantity = null;
      this.oldGold.grossWeight = 0;
      this.oldGold.netWeight = 0;
      this.oldGold.stoneWeight = 0;
      this.oldGold.melt = 0;
      this.oldGold.itemAmount = 0;
      this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
      this.getData();

          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    
    addVariant() {
      console.log("3")
      this.oldItemz.push(JSON.parse(JSON.stringify(this.peritem)));
      console.log("oldItemz=", this.oldItemz);
      //////
      this.oldGold.itemName = null;
      // this.oldGold.quantity = null;
      this.oldGold.grossWeight = null;
      this.oldGold.netWeight = null;
      this.oldGold.stoneWeight = null;
      this.oldGold.melt = null;
      this.oldGold.itemAmount = null;
      this.addOldItem();
      this.oldItemz=[];
    },
    getData() {
      axios({
        url: "/oldgolditem/getlist",
        method: "get",
        params: {
          salesId: this.salesId,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.List = response.data.data;
            // this.saleId = response.data.saledata._id;
            this.saledata = response.data.bill;
          } else {
            // this.msg = response.data.msg;
            // this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteStaff() { 
      axios({
        url: "/oldgolditem/delete",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.curId,
        },
      })
        .then((response) => {
          this.dialoge = false;
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.dialoge=false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
   
    editItem() {
      console.log("curitem=", this.curitem);
      axios({
        url: "/oldgolditem/edit",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.curitem._id,
          items: this.curitem
        },
      })
        .then((response) => {
          this.editdialogue = false;
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.editdialogue=false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.old-gold-container {
  color: #1e293b;
}

.estimate-gold-card {
  background: #ffffff !important;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.card-top-bar {
  background: #fafafa;
}

.card-heading {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #0f172a;
}

.items-count-badge {
  display: inline-block;
  padding: 2px 8px;
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #475569;
}

.old-gold-grid {
  display: grid;
  grid-template-columns: minmax(140px, 1.1fr) minmax(120px, 1fr) minmax(130px, 1fr) minmax(130px, 1fr) minmax(130px, 1fr) minmax(110px, 0.9fr) 46px;
  gap: 12px;
  align-items: flex-start;
}

.grid-item {
  display: flex;
  flex-direction: column;
}

.grid-action-item {
  display: flex;
  flex-direction: column;
}

.action-label-placeholder {
  visibility: hidden;
  user-select: none;
  pointer-events: none;
}

.erp-field-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  margin-bottom: 5px;
  white-space: nowrap;
}

.erp-field >>> .v-input__slot {
  border-radius: 8px !important;
  font-size: 13.5px;
}

.erp-readonly >>> .v-input__slot {
  background-color: #f8fafc !important;
}

.erp-add-gold-btn {
  background: linear-gradient(135deg, #b9893f 0%, #875c24 100%) !important;
  background-color: #9a6b27 !important;
  color: #ffffff !important;
  height: 40px !important;
  min-width: 46px !important;
  width: 46px !important;
  border-radius: 10px !important;
  transition: all 0.25s ease !important;
  box-shadow: 0 4px 14px rgba(154, 106, 44, 0.28) !important;
}

.erp-add-gold-btn:hover {
  background: linear-gradient(135deg, #c59449 0%, #956627 100%) !important;
  box-shadow: 0 6px 18px rgba(154, 106, 44, 0.38) !important;
  transform: translateY(-1.5px) !important;
}

/* Old Gold Table */
.erp-table-card {
  border: 1px solid #e2e8f0;
}

.erp-gold-table thead {
  background-color: #f8fafc;
}

.erp-gold-table thead th {
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #475569 !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.erp-gold-table tbody td {
  font-size: 12.5px !important;
  color: #1e293b;
  border-bottom: 1px solid #f1f5f9 !important;
}

.table-row-hover:hover {
  background-color: #f8fafc;
}

.table-summary-bar {
  background-color: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.summary-pill {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
}

.pill-label {
  color: #64748b;
  margin-right: 6px;
}

.pill-val {
  color: #0f172a;
}

.highlight-pill {
  border-color: #a7f3d0;
  background-color: #ecfdf5;
}

.highlight-pill .pill-val {
  color: #065f46;
}

/* Modals */
.erp-modal-card {
  background: #ffffff !important;
}

.modal-top-bar {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.modal-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

.modal-subtext {
  font-size: 12px;
  color: #64748b;
}

.bg-modal-footer {
  background-color: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.erp-action-btn {
  background: linear-gradient(135deg, #b9893f 0%, #875c24 100%) !important;
  background-color: #9a6b27 !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  border-radius: 10px !important;
  box-shadow: 0 4px 14px rgba(154, 106, 44, 0.28) !important;
  transition: all 0.25s ease !important;
}

.erp-action-btn:hover {
  background: linear-gradient(135deg, #c59449 0%, #956627 100%) !important;
  box-shadow: 0 6px 18px rgba(154, 106, 44, 0.38) !important;
  transform: translateY(-1.5px) !important;
}

@media (max-width: 960px) {
  .old-gold-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .grid-action-item {
    grid-column: span 3;
    justify-content: flex-end;
  }
}

@media (max-width: 600px) {
  .old-gold-grid {
    grid-template-columns: 1fr;
  }
  .grid-action-item {
    grid-column: span 1;
  }
}
</style>
